import * as types from './types';

export const openSearch = () => {
	return {
		type: types.OPEN_SEARCH
	}
}

export const closeSearch = () => {
	return {
		type: types.CLOSE_SEARCH
	}
}

export const setSearchStep = (step) => {
	return {
		type: types.SET_SEARCH_STEP,
		step
	}
}


// WEBPACK FOOTER //
// ./src/actions/search.js